import { atom } from "nanostores";

export interface Tool { name: string; activate(): void }

/** The tool in use, if any; marker mode follows it (spec 2h §2.2). Esc, another slot or a panel clears it. */
export const $activeTool = atom<string | null>(null);

/** Tools a hotbar slot can hold, by id; must match the server's settings.KnownTools. */
export const TOOLS: Record<string, Tool> = {
  marker: { name: "agent 標記", activate: () => $activeTool.set($activeTool.get() === "marker" ? null : "marker") },
};

export function activateTool(id: string): void {
  TOOLS[id]?.activate();
}

export const toolName = (id: string): string => TOOLS[id]?.name ?? id;

/** Whether ✓ would do something now: the placement is valid, or the marker tool has a place to mark (spec 2p §2.4). */
export const $confirmReady = atom(false);
